export const getQuickCardObjectName = (isModal: boolean) =>
  isModal ? 'quickCardObject' : 'quickChildCardObject';

export const getQuickCardFilesToUpdateName = (isModal: boolean) =>
  isModal ? 'quickCardFilesToUpdate' : 'quickChildCardFilesToUpdate';
